/*
 * 作者: Fultom
 * 创建时间: 2024-04-12 09:41:51
 * 最近修改时间: 2024-04-23 16:20:40
 * 功能: 
 */
/**
 * Created by PursuitStar on 2020/07/27
 * Desc: 经销商项目路由表配置
 */
const _import = require('./_import_' + process.env.NODE_ENV);
const physicalStoreProjectRoute = [{
    path: '/physicalStore/phone',
    name: 'physicalStore_phone',
    component: _import('agent/physicalStore/mobileMode/index'),
    hidden: true,
    meta: {
      title: '自然人认证'
    },
  },
  {
    path: '/physicalStore/person',
    name: 'physicalStore_person',
    component: _import('agent/physicalStore/personMode/index'),
    hidden: true,
    meta: {
      title: '个体工商户认证'
    },
  },
  {
    path: '/physicalStore/enterprise',
    name: 'physicalStore_enterprise',
    component: _import('agent/physicalStore/enterpriseMode/index'),
    hidden: true,
    meta: {
      title: '企业认证'
    },
  },
  {
    path: '/physicalStore/contract',
    name: 'physicalStore_contract',
    component: _import('agent/physicalStore/contract/index'),
    hidden: true,
    meta: {
      title: '签署合同'
    },
  },
  {
    path: '/physicalStore/sign',
    name: 'physicalStore_sign',
    component: _import('agent/physicalStore/sign/index'),
    hidden: true,
    meta: {
      title: '签署合同'
    },
  },
  {
    path: '/physicalStore/transferSign',
    name: 'physicalStore_transferSign',
    component: _import('agent/physicalStore/transferSign/index'),
    hidden: true,
    meta: {
      title: '签署合同'
    },
  },
  {
    path: '/physicalStore/electronicReceipt',
    name: 'physicalStore_electronicReceipt',
    component: _import('agent/physicalStore/electronicReceipt/index'),
    hidden: true,
    meta: {
      title: '电子收据'
    },
  },

];
export default physicalStoreProjectRoute;



// WEBPACK FOOTER //
// ./src/router/physicalStoreProject.js